<template>
<q-card class="column" style="flex-wrap:nowrap" flat bordered>
  <div class="card-title" :style="{padding: paddingTitle}">
    <slot name="header"></slot>
  </div>
  <q-separator />
  <div class="row col" style="align-items:center;" :style="{padding: paddingBody}">
    <slot name="body"></slot>
  </div>
</q-card>
</template>

<script>
export default{
  props: ['styles'],
  computed: {
    paddingTitle: function () {
      if (this.styles != undefined) {
        if (this.styles.paddingTitle != undefined)
          return this.styles.paddingTitle;
      }
      return "0px 20px";
    },
    paddingBody: function () {
      if (this.styles != undefined) {
        if (this.styles.paddingBody != undefined)
          return this.styles.paddingBody;
      }
      return "0px 20px";
    }
  }
}
</script>


<style scoped>
.card-title {
  flex:0 0 40px;
  display:flex;
  flex-direction:row;
  align-items:center;
}
</style>